module.exports = __webpack_public_path__ + "img/Flag_of_Liechtenstein.071b1d57.svg";